export default __webpack_public_path__ + "50a7a56d0e490776af12f2b5c5efd9e7.png";